import React from 'react';
import { Link } from "react-router-dom"
import { Col, Row } from "react-bootstrap"

const HaveAnAccount = props => {
  const { align = 'right', tenancy } = props;

  return (
    <Row className="pt-2 pb-3">
      <Col className={`text-${align}`}>
        ¿Ya tienes cuenta? { ' ' }
        <Link to={`/auth/login${tenancy ? '?tenancy=' + tenancy : ''}`}>
          Inicia sesión
        </Link>
      </Col>
    </Row>
  )
}

export {
  HaveAnAccount
}